import * as React from 'react';
import { cn } from '@/lib/utils';

// Size token → Tailwind class
const sizeMap = {
  xs:  'size-3.5', // 14px — inline indicators, input fields
  sm:  'size-4',   // 16px — inside buttons, compact rows
  md:  'size-5',   // 20px — row-level, next to text
  lg:  'size-6',   // 24px — section/card loaders
  xl:  'size-8',   // 32px — page-level loaders
  '2xl': 'size-12',// 48px — full-screen overlays
} as const;

export type SpinnerSize = keyof typeof sizeMap;

interface SpinnerProps {
  size?: SpinnerSize;
  className?: string;
}

export const Spinner: React.FC<SpinnerProps> = ({ size = 'md', className }) => (
  <svg
    className={cn('animate-spin shrink-0 text-primary', sizeMap[size], className)}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <circle
      className="opacity-25"
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeWidth="4"
    />
    <path
      className="opacity-75"
      fill="currentColor"
      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    />
  </svg>
);
